import React, { useState, useEffect } from "react";
import { deleteCard } from "../../../services/api";
import colors from "../../../theme";
import SnackbarComp from "../../../components/Snackbar/SnackbarComp";

import AmericanExpress from "../../../assets/CardLogos/AmericanExpress.png";
import Discover from "../../../assets/CardLogos/Discover.png";
import JCB from "../../../assets/CardLogos/JCB.png";
import MasterCard from "../../../assets/CardLogos/MasterCard.png";
import Visa from "../../../assets/CardLogos/Visa.png";
import UnionPay from "../../../assets/CardLogos/UnionPay.png";
import DinersClub from "../../../assets/CardLogos/DinersClub.png";

import {
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  CircularProgress,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { setCardBeingCharged } from "../../../store/cardChargedSlice";

const CurrentBankCard = ({ cardDetails, onDelete }) => {
  const [error, setError] = useState(null);
  const [statusCode, setStatusCode] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const dispatch = useDispatch();

  const cardBeingCharged = useSelector(
    (state) => state.cardCharged.cardBeingCharged
  );

  useEffect(() => {
    if (cardBeingCharged) {
      setOpenSnackbar(true);
      setStatusCode(200);
      setError("Your card is being charged, wait for few moments...");
      setIsButtonDisabled(true);
      const timer = setTimeout(() => {
        setIsButtonDisabled(false);
        dispatch(setCardBeingCharged(false));
      }, 5000);
      return () => clearTimeout(timer);
    }
  }, [cardBeingCharged, dispatch]);

  const cardLogos = {
    Visa: Visa,
    MasterCard: MasterCard,
    "American Express": AmericanExpress,
    Discover: Discover,
    JCB: JCB,
    UnionPay: UnionPay,
    "Diners Club": DinersClub,
  };

  const handleDeleteCard = async (id) => {
    try {
      setIsLoading(true);
      const response = await deleteCard(id);
      setOpenSnackbar(true);
      setStatusCode(response.status);
      setError(response.message);
      setOpenConfirmDialog(false);
      await onDelete();
      setIsLoading(false);
    } catch (error) {
      console.error("Error deleting card:", error);
      setOpenSnackbar(true);
      setStatusCode(error.response.data.status);
      setError(error.response.data.message);
      setOpenConfirmDialog(false);
    } finally {
      setIsLoading(false);
    }
  };

  const handleRemoveClick = () => {
    setOpenConfirmDialog(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };
  const isEmptyCardDetails = () => {
    return !cardDetails.id;
  };

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <Card
        sx={{
          backgroundColor: colors.mainContentBgColor,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          maxWidth: 400,
          position: "relative",
        }}
      >
        <CardContent>
          {isEmptyCardDetails() ? (
            <Typography
              variant="h6"
              sx={{
                textAlign: "center",
                color: colors.primary,
              }}
            >
              No card found
            </Typography>
          ) : (
            <>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      textAlign: "center",
                    }}
                  >
                    {cardLogos[cardDetails.brand] ? (
                      <img
                        src={cardLogos[cardDetails.brand]}
                        alt={cardDetails.brand}
                        style={{ width: 70, height: 40 }}
                      />
                    ) : (
                      <Typography variant="h6">{cardDetails.brand}</Typography>
                    )}
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1">Card Number</Typography>
                    <Typography variant="body1">
                      {cardDetails.lastFour}
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12}>
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Typography variant="body1">Expires</Typography>
                    <Typography variant="body1">
                      {cardDetails.expiryDate}
                    </Typography>
                  </Box>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      marginTop: 1,
                      backgroundColor: colors.secondary,
                      "&:hover": {
                        backgroundColor: colors.btnBackgroundColorOnHover,
                      },
                    }}
                    onClick={handleRemoveClick}
                    disabled={isButtonDisabled}
                  >
                    Remove Card
                  </Button>
                </Grid>
              </Grid>
            </>
          )}
        </CardContent>
      </Card>

      <SnackbarComp
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        errorMessage={error}
        statusCode={statusCode}
      />

      <Dialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        PaperProps={{
          sx: {
            bgcolor: colors.mainContentBgColor,
          },
        }}
      >
        <DialogTitle>Remove Card?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to Remove this card?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenConfirmDialog(false)}
            sx={{ color: colors.secondary }}
          >
            Cancel
          </Button>
          <Button
            onClick={() => handleDeleteCard(cardDetails.id)}
            sx={{
              color: colors.text,
              backgroundColor: colors.secondary,
              "&:hover": {
                backgroundColor: colors.btnBackgroundColorOnHover,
              },
            }}
            autoFocus
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={24} /> : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default CurrentBankCard;
